module.exports = __webpack_public_path__ + "assets/img/YY.f42a5b85.png";